module.exports = __webpack_public_path__ + "static/media/test6_4.8d33fdb9.png";